import React from 'react'

import { observer } from 'mobx-react'
import { NavLink } from 'react-router-dom'

import cn from 'classnames'

import {
  clickDMCAPolicy,
  clickTermsAndConditions,
  clickUserPolicy,
  clickWhitepaper,
  getDiscordLink,
  getTelegramLink,
  getTwitterLink,
  privacy_policy_link,
  terms_of_service_link,
} from 'utils'

import { FooterPWA } from 'componentsPWA/FooterPWA'

import { useStore } from 'store'

import companyIconWhite from 'sources/images/companyIconWhite.svg'
import discord from 'sources/images/discord.png'
import { ReactComponent as EthereumIcon } from 'sources/images/ethereumIcon.svg'
import { ReactComponent as IpfsIcon } from 'sources/images/ipfsIcon.svg'
import mail from 'sources/images/mail.png'
import { ReactComponent as PolygonIcon } from 'sources/images/polygonIcon.svg'
import telegram from 'sources/images/telegram.png'
import twitter from 'sources/images/twitter.png'

import styles from './styles.module.scss'

interface IProps {}

//Resize
const Footer: React.FC<IProps> = observer(() => {
  const { main } = useStore()

  if (main.isPWA) {
    return <FooterPWA />
  }

  return (
    <footer
      className={cn({
        [styles.footer]: true,
      })}
    >
      <div className={styles.boxContent}>
        <div className={styles.logoBox}>
          <img
            src={companyIconWhite}
            alt="companyIconWhite"
            className={styles.img}
          />
          <div className={styles.rightsText} onClick={clickDMCAPolicy}>
            © {new Date().getFullYear()} Authencity. All rights reserved.
          </div>
          <div className={styles.rightsTextMobile} onClick={clickDMCAPolicy}>
            © {new Date().getFullYear()} Authencity. <br /> All rights reserved.
          </div>
        </div>

        <div className={styles.poweredBy}>
          <div className={styles.poweredByTitle}>Powered by:</div>
          <div className={cn(styles.ethereumIcon, styles.icon)}>
            Ethereum <EthereumIcon />
          </div>
          <div className={cn(styles.polygonIcon, styles.icon)}>
            Polygon <PolygonIcon />
          </div>
          <div className={cn(styles.ipfsIcon, styles.icon)}>
            IPFS <IpfsIcon />
          </div>
        </div>

        <div className={styles.links}>
          <NavLink className={styles.link} to={terms_of_service_link()}>
            Terms of service
          </NavLink>
          <NavLink className={styles.link} to={privacy_policy_link()}>
            Privacy policy
          </NavLink>
        </div>
        <div className={styles.wrapSocialBtn}>
          <a
            className={styles.socialBtn}
            style={{ marginLeft: 0 }}
            href={getTelegramLink()}
            target="_blank"
            rel="noreferrer noopener"
          >
            <img src={telegram} alt="telegram" className={styles.socialLogo} />
          </a>
          <a
            className={styles.socialBtn}
            href={getTwitterLink()}
            target="_blank"
            rel="noreferrer noopener"
          >
            <img src={twitter} alt="twitter" className={styles.socialLogo} />
          </a>
          <a
            className={styles.socialBtn}
            href={getDiscordLink()}
            target="_blank"
            rel="noreferrer noopener"
          >
            <img src={discord} alt="discord" className={styles.socialLogo} />
          </a>
          <a className={styles.socialBtn} href="mailto:contact@authencity.io">
            <img src={mail} alt="mail" className={styles.socialLogo} />
          </a>
        </div>
      </div>
    </footer>
  )
})

export default Footer
